import { render, staticRenderFns } from "./forusDevice.vue?vue&type=template&id=22e8bfa6&scoped=true&"
import script from "./forusDevice.vue?vue&type=script&lang=js&"
export * from "./forusDevice.vue?vue&type=script&lang=js&"
import style0 from "./forusDevice.vue?vue&type=style&index=0&id=22e8bfa6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8bfa6",
  null
  
)

export default component.exports